var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function isDefined(item) {
    return item != null;
}
export function delay(s) {
    return new Promise((resolve) => setTimeout(resolve, s * 1000));
}
export function timeout(promise, timeout) {
    return __awaiter(this, void 0, void 0, function* () {
        const timeoutPromise = new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), timeout));
        return Promise.race([promise, timeoutPromise]);
    });
}
export function url(url, params) {
    const search = Array.from(params.entries()).length > 0 ? `?${params}` : '';
    return `${url}${search}`;
}
export function isAbsoluteUrl(url) {
    return /^(?:[a-z]+:)?\/\//.test(url);
}
export function isNode(e) {
    return e != null && 'nodeType' in e;
}
export function blankedAddress(address, displayLength = 24) {
    return address.length > displayLength
        ? `${address.slice(0, displayLength / 2)}...${address.slice(address.length - displayLength / 2)}`
        : address;
}
export function toBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result ? reader.result : undefined);
        reader.onerror = (e) => reject(e);
    });
}
